import Icon from '../components/Icon.vue'

Icon.register({
  'concierge-bell': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M288 130.5c108.5 15.6 192 108.6 192 221.5h-448c0-112.8 83.5-205.9 192-221.5v-18.5h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16v18.5zM496 384c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-480c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h480z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/concierge-bell.js
// module id = 1235
// module chunks = 0